import createSpinner from "../../../Shared/Functions/createSpinner";

export default /*@ngInject*/ function ($uibModalInstance, AuditTrailEntityDataService, template, availableCompanies, productId, helperService) {

    const vm = this;
    vm.template = { ...template };
    vm.availableCompanies = [...availableCompanies];
    vm.cancel = cancel;
    vm.save = save;
    vm.addCompanyToList = addCompanyToList;
    vm.deleteselectedCompany = deleteselectedCompany;

    vm.selectedCompanies = [];

    activate();

    async function activate() {
        await getSelectedCompanies();
        filterAvailableCompanies();  
    }

    function filterAvailableCompanies() {
        vm.selectedCompanies.forEach(selectedCompany => {
            vm.availableCompanies = vm.availableCompanies.filter(company => company.ID !== selectedCompany.ID);
        });
    }

    function addCompanyToList(company) {
        vm.selectedCompanies.push(company);
        const selectedCompanyIndex = vm.availableCompanies.findIndex(item => item.ID === company.ID);
        vm.availableCompanies.splice(selectedCompanyIndex, 1);
    }

    function deleteselectedCompany(company) {
        vm.availableCompanies.push(company);
        const removedCompanyIndex = vm.selectedCompanies.findIndex(item => item.ID === company.ID);
        vm.selectedCompanies.splice(removedCompanyIndex, 1);
    }

    async function getSelectedCompanies() {
        let response = await AuditTrailEntityDataService.getTableCompanyTrackingEntries(productId, template.Id);
        vm.selectedCompanies = response.data.map(selectedCompany => {
            return { Name: selectedCompany.CompanyName, ID: selectedCompany.CompanyId };
        });
    }

    function cancel() { $uibModalInstance.dismiss(); }

    async function save() {
        vm.saving = new createSpinner();
        let companiesArray = vm.selectedCompanies.map(company => company.ID);
        await helperService.successfulSaveButton(vm.saving);
        $uibModalInstance.close(companiesArray);
    }
}